import { createReducer } from '@reduxjs/toolkit';

import { loadUserByIdStart, loadUserByIdSuccess, loadUsersListSuccess, loadUsersStart, resetUserById } from './actions';
import { IUser, IUsersReducer } from './types';

const initialState: IUsersReducer = {
  list: { isLoading: false, isLoaded: false, data: [] as IUser[] },
  item: { isLoading: false, isLoaded: false, data: {} as IUser },
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadUsersStart, (state) => ({ ...state, list: { ...state.list, isLoading: true } }))
    .addCase(loadUsersListSuccess, (state, action) => ({
      ...state,
      list: { ...state.list, isLoading: false, isLoaded: true, data: action.payload },
    }))
    .addCase(loadUserByIdStart, (state) => ({ ...state, item: { ...state.item, isLoading: true } }))
    .addCase(loadUserByIdSuccess, (state, action) => ({
      ...state,
      item: { ...state.item, isLoading: false, isLoaded: true, data: action.payload },
    }))
    .addCase(resetUserById, (state) => ({
      ...state,
      item: { isLoading: false, isLoaded: false, data: {} as IUser },
    }));
});
